module.exports = __webpack_public_path__ + "img/broadcast.94747cc4.png";